<template>
  <div class="t-card"  :class="{ 'smallcard': coin.small, 'active': coin.active }">
    <div class="blue-line"></div>
    <div class="first-box" @click="expandCoin(coin)">
      <div class="tc-info">
        <div class="ci-logo">
          <img :src="coin.logoPath" :class="{ 'gray': amount == 0 }">
        </div>
        <div class="ci-name">
          <div class="ci-name-full">{{ coin.name }}</div>
          <div class="ci-name-small">{{ coin.symbol }}</div>
        </div>
      </div>
      <div class="tc-price">
        <div class="tc-price-full">{{ currentPrice }} USD</div>
        <div class="tc-price-small">Rate</div>
      </div>
    </div>
    <div class="tc-select" >
      <div class="amount-select">
        <div class="range-field">
          <input type="range" name="range" min="0" :max="getMaxForTier()" step="1" v-model="amount" :class="{active: amount > 0}"
            @change="checkActiveAmount(coin)">
          <div class="slide" :style="{ width: slideWidth }" ></div>
        </div>
      </div>
    </div>
    <div class="tc-btns">
      <div class="form-group">
        <input type="text" class="tc-amount" :class="{ active: amount > 0 }" v-model="amount" @input="amount = $event.target.value != '' ? $event.target.value : 0"
          @click="checkActiveAmount(coin)" value="0">
        <div class="fg-amount-name">USD</div>

        <transition name="fade">
          <div class="result-volume" v-if="amount > 0">
            ~ {{ computeResult.toFixed(4) }} <b>{{ coin.symbol }}</b>
          </div>
        </transition>
      </div>

      <router-link to="/payment">
        <div class="tc-btn" :class="{'buy-btn-choosen': amount > 0 }" @click="buyOrder(coin)">Buy</div>
      </router-link>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  name: "t-card",
  props: ["coin"],
  data() {
    return {
      amount: 0
    };
  },
  methods: {
    ...mapActions("coins", ["smallAllCoins"]),
    ...mapActions("orders", ["createOrder"]),
    expandCoin(coin) {
      this.smallAllCoins(this.coin, this.small)
    },
    checkActiveAmount() {},
    getMaxForTier() {
      return 5000;
    },
    buyOrder(coin) {
      console.log("createOrder")
      this.createOrder({coin: this.coin, currency: "USD"})
    },
    checkActiveAmount(coin) {}
  },
  computed: {
    slideWidth() {
      return (
        "calc(" +
        this.amount / (this.getMaxForTier() / 100) +
        "% - " +
        22 / this.getMaxForTier() * this.amount +
        "px)"
      );
    },
    computeResult() {
      return this.amount / this.coin.price.value
    },
    currentPrice() {
      return this.coin.price.value.toFixed(2);
    },
    getImage() {
      return this.logoPath;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/elements/trading/card.vue